import { CommonModule, NgIf, NgSwitchCase } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { QuadrantInfo } from '../../../models/QuadrantInfo';
import { TableHeader } from "../../../models/Table/TableHeader";
import { PaginatorComponent } from "../paginator/paginator.component";
import { Paginator } from "../../../models/Paginator";
import { InputSwitchModule } from 'primeng/inputswitch';
import { FormsModule } from '@angular/forms';
import { TableActions } from '../../../models/Table/TableActions';
import { Reservation } from '../../../models/Reservation';
import { TableModule } from 'primeng/table';
import { GenericTableComponent } from "../generic-table/generic-table.component";
import { ReservationService } from "../../../core/services/reservations/reservation.service";
import { StationService } from "../../../core/services/stations/station.service";
import { UserService } from "../../../core/services/users/user.service";
import { SortColumn } from '../../../models/Table/SortColumn';
import { ActiveFilter } from '../../../models/Table/ActiveFilter';
import { VehiclesService } from "../../../core/services/vehicles/vehicles.service";
import { Vehicle } from '../../../models/Vehicle';
import { stringify } from 'postcss';
import { info } from 'autoprefixer';
import { FrontBackDirective } from '../../directives/buttons/front.back.directive';
import { Router, RouterModule } from '@angular/router';
import { forkJoin } from 'rxjs';
import { update } from '@angular-devkit/build-angular/src/tools/esbuild/angular/compilation/parallel-worker';
import { UserV2 } from '../../../models/UserV2';


@Component({
  selector: 'app-info-day-modal',
  standalone: true,
  imports: [NgIf,
    CommonModule,
    InputSwitchModule,
    FormsModule,
    TableModule,
    GenericTableComponent,
    FrontBackDirective,
    RouterModule],
  templateUrl: './info-day-modal.component.html',
  styleUrls: ['./info-day-modal.component.css']
})
export class InfoDayModalComponent<T> {

  @Input() isOpen: boolean = false;
  @Input() isShowInfoDay: boolean = false;
  @Input() infoDay: string = '';

  @Input() quadrantInfo: QuadrantInfo | undefined;
  @Input() items: Paginator<any> | null = null;
  @Input() items2: any[] | null = null;
  @Output() close = new EventEmitter<void>();
  @Input() onBooleanClick: EventEmitter<{ header: TableHeader, item: T, index: number }> = new EventEmitter<{ header: TableHeader, item: T, index: number }>();
  @Input() loading: boolean = false;
  @Input() Perpage: number = 10;
  reservations: Paginator<Reservation> | null = null;
  visible: boolean = false;

  tableHeaders: TableHeader[] = [
    {
      name: 'MATRÍCULA',
      active: true,
      td_type: 'text',
      td_key: 'registration_number',
      sort: false,
    },
    {
      name: 'HORA',
      td_type: 'text',
      td_key: 'hour',
      active: true,
      table: 'hours',
      td_sub_key: 'hour',
      sort: true,
    },
    {
      name: 'TIPO VEHÍCULO',
      td_type: 'text',
      td_key: 'vehicle',
      active: true,
      table: 'vehicles',
      td_sub_key: 'name',
      sort: true,
    },
    {
      name: 'ESTADO',
      active: true,
      td_type: 'boolean',
      td_key: 'state',
      sort: false,
    },
  ]
  sorts: SortColumn[] = [];
  filters: ActiveFilter[] = [];
  associations: UserV2[] = [];

  constructor(private reservationService: ReservationService,
    private vehiclesService: VehiclesService,
    private cdRef: ChangeDetectorRef,
    private stationService: StationService,
    private userService: UserService,
    private router: Router
  ) {
    this.loading = true;

    this.userService.listAssociations().subscribe({
      next: (response) => {
        this.associations = response.data || [];
        this.loadFilters();
      },
      error: (err) => {
        console.error('Error al obtener las asociaciones:', err);
      },
      complete: () => {
        this.loadReservation();
        this.loadFilters();
        this.loading = false;
      }
    });

  }

  ngOnDestroy() {
    this.infoDay = '';
    this.quadrantInfo = undefined;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.isOpen) {
      this.showModal();
    } else {
      this.hideModal();
    }
    this.loading = true;
    this.loadFilters();
    this.loadReservation();
  }

  isVisible: boolean = false;
  animationClass: string = '';

  showModal() {
    this.isVisible = true;
    this.animationClass = 'modal-enter';
  }

  hideModal() {
    this.animationClass = 'modal-exit';
    setTimeout(() => {
      this.isVisible = false;
      this.close.emit();
    }, 300);
  }
  handleBackgroundClick() {
    this.isOpen = false;
    this.hideModal();
  }

  loadFilters() {

    this.filters = [];

    if (this.infoDay) {
      let dayInfo = this.getDayInfo(this.infoDay);

      if (dayInfo) {
        let { dayStart, dayEnd } = this.getDayRange(dayInfo);
        if (!this.filters.some(f => f.column === 'date-arr')) {
          this.filters.push({
            column: "date",
            format: "dd/MM/yyyy",
            operator: "between",
            parsed: "date-arr",
            value: [dayStart, dayEnd],
          });
        }
        if (!this.filters.some(f => f.column === 'station_id')) {
          this.filters.push({
            column: "station_id",
            operator: "=",
            parsed: 'relationship-arr',
            relation_column: 'name',
            relation_filter_column: 'id',
            value: this.quadrantInfo?.quadrant.station_id,
          });
        }

        if (!this.filters.some(f => f.column === 'vehicle_id')) {
          this.filters.push({
            column: "vehicle_id",
            operator: "in",
            value: this.quadrantInfo?.quadrant.vehicles,
            parsed: 'relationship-arr',
            relation_column: 'name',
            relation_filter_column: 'id',
          });
        }

        if (!this.filters.some(f => f.column === 'service_id')) {
          this.filters.push({
            column: "service_id",
            operator: "in",
            value: this.quadrantInfo?.quadrant.services,
            parsed: 'relationship-arr',
            relation_column: 'name',
            relation_filter_column: 'id',
          });
        }

        if (this.quadrantInfo?.quadrant.professional && this.quadrantInfo?.quadrant.association_id) {
          if (!this.filters.some(f => f.column === 'professional_id')) {
            let association = this.associations.filter(user=>user.id == this.quadrantInfo?.quadrant.association_id);
            this.filters.push({
              column: "professional_id",
              operator: "=",
              value: association,
              parsed: 'relationship-arr',
              relation_column: 'name',
              relation_filter_column: 'id',
            });
          }
        }

        if (this.quadrantInfo?.quadrant.professional && !this.quadrantInfo?.quadrant.association_id) {
          if (!this.filters.some(f => f.column === 'professional')) {
            this.filters.push({
              column: "professional",
              operator: "=",
              value: this.quadrantInfo?.quadrant.professional,
              parsed: 'relationship-arr',
              relation_column: 'name',
              relation_filter_column: 'id',
            });

            this.filters.push({
              column: 'professional_id',
              operator: 'notIn',
              value: this.associations,
              parsed: 'relationship-arr',
              relation_column: 'name',
              relation_filter_column: 'id',
            });
          }
        } else {
          if (!this.filters.some(f => f.column === 'professional')) {
            this.filters.push({
              column: "professional",
              operator: "=",
              value: this.quadrantInfo?.quadrant.professional,
              parsed: 'relationship-arr',
              relation_column: 'name',
              relation_filter_column: 'id',
            });
          }
        }
        
        if (this.quadrantInfo?.quadrant.type === 'locked') {
          this.filters.push({
            column: "locked",
            operator: "=",
            value: 1
          });
        } else {
          this.filters.push({
            column: "locked",
            operator: "=",
            value: 0
          });
        }
        
        localStorage.setItem('itv_reservation_filters', JSON.stringify(this.filters))
        this.sorts.push({ column: 'hour', order: 'asc', relationship: { "table": "hours", "column": "hour" } });
        localStorage.setItem('itv_info_day_modal_sorts', JSON.stringify(this.sorts));
      }
    }
  }

  onFilterByVehicleType(item: any) {
    const existingFilter = this.filters.find(filter => filter.column === 'vehicle_id');

    if (existingFilter) {
      if (item.key !== 'total') {
        const vehicleType = this.quadrantInfo?.quadrant.vehicles.find(vehicle => vehicle.short_name === item.key);
        existingFilter.value = vehicleType ? [vehicleType] : [];
        this.loadReservation();
      } else {
        existingFilter.value = this.quadrantInfo?.quadrant.vehicles ?? [];
      }
      this.loadReservation();
    }

  }

  loadReservation() {
    this.loading = true;
    this.reservationService.list(this.sorts, this.filters, this.Perpage).subscribe({
      next: data => {
        if (data.data) {
          this.reservations = data.data;
        } else {
          this.reservations = null;
        }
        this.loading = false;
      },
      error: err => {
        this.loading = false;
      },
    });
  }

  closeModal() {
    setTimeout(() => {
      this.isShowInfoDay = false;
      this.close.emit();
    }, 300);

  }

  onBackgroundClick(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.closeModal();
    }
  }

  booleanClick(header: TableHeader, index: number) {
    this.onBooleanClick.emit({ header, item: this.items!.data[index], index })
  }

  getDayInfo(date: string) {
    if (this.quadrantInfo) {
      let dayInfo = this.quadrantInfo.daysInfo.find(d => d.date === date);
      this.getDayRange(dayInfo);
      return dayInfo;
    }
    return null;
  }
  getDayRange(dayInfo: any) {
    const parsedDate = new Date(dayInfo.date);
    const dayStart = new Date(parsedDate);
    dayStart.setHours(0, 0, 0, 0); // Hoy a las 00:00:00

    const dayEnd = new Date(parsedDate);
    dayEnd.setHours(23, 59, 59, 999); // Hoy a las 23:59:59

    return { dayStart, dayEnd };
  }
  goToCalendarWithFilters() {
    const filtersWithDateObjects = this.filters.map(filter => {
      if (filter.column === 'date' && Array.isArray(filter.value)) {
        return {
          ...filter,
          value: filter.value.map(dateString => new Date(dateString))
        };
      }
      return filter;
    });

    const stationFilter = this.filters.find(f => f.column === 'station_id');
    let stationIds: number[] = [];

    if (stationFilter?.value !== undefined && stationFilter?.value !== null) {
      stationIds = [stationFilter.value];
    }
    if (stationIds.length > 0) {
      const stationRequests = stationIds.map(id => this.stationService.getById(id));

      forkJoin(stationRequests).subscribe({
        next: (responses) => {
          const stationObjects = responses.map(res => res.data);

          const updatedFilters = filtersWithDateObjects.map(filter => {
            if (filter.column === 'station_id') {
              return {
                ...filter,
                column: "station_id",
                operator: "in",
                parsed: 'relationship-arr',
                relation_column: 'name',
                relation_filter_column: 'id',
                value: stationObjects
              };
            }
            return filter;
          });

          localStorage.setItem('itv_reservation_filters', JSON.stringify(updatedFilters));
          this.router.navigate(['/dashboard/agenda-diaria']);
        }
      });
    } else {
      localStorage.setItem('itv_reservation_filters', JSON.stringify(filtersWithDateObjects));
      this.router.navigate(['/dashboard/agenda-diaria']);
    }
  }
  onChangeSorts(sorts: SortColumn[]): void {
    this.sorts = sorts;
    localStorage.setItem('itv_reservation_sorts', JSON.stringify(this.sorts))
    this.loadReservation();
  }
}